var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page_content_wrapper"},[_c('div',{staticClass:"p_body"},[_c('board-bookmarks'),_c('hr'),_c('board-attachments',{staticClass:"has-padding-bottom-3"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }